<template>
  <v-card>
    <v-card-text>
      <h1 class="host-dashboard-title">Host FAQ</h1>
      <v-expansion-panel>
        <v-expansion-panel-content>
          <div slot="header">What is a wrkprty?</div>
          <v-card>
            <v-card-text>
              A wrkprty is a meeting of professional adults coming together and working side by side,
              taking breaks together and powering through worksprints together. 
              A work party is usually one morning, one afternoon, or one evening in which people get together
               to focus together and have some fun in between.
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header">Do people at a wrkprty collaborate on their work?</div>
          <v-card>
            <v-card-text>
              Usually not. Typically everybody brings his or her own work and works silently during the sprints. 
              However, getting some help and work related advice from other wrkprty members can be incredibly helpful. 
              We recommend talking about issues during breaks or at the end of a wrkprty. 
              You would be surprised how willing our community is to help.
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header">What is a work sprint?</div>
          <v-card>
            <v-card-text>
              A sprint is a timed period in which all wrkprty attendees sit down and try to be as productive as possible. 
              Usually a sprint is about 45 min long and will be followed with a short break. 
              In that time period we encourage guests to be silent and focused, and to set a goal. 
              We call it a sprint because it is similar to running: You can walk or jog around for a while but you can also sprint, 
              which takes you where you want to get much faster.
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header">What happens during a break?</div>
          <v-card>
            <v-card-text>
              Breaks are usually announced by the host. 
              It's a time for everybody to get up, stretch their legs and refill their coffees. 
              Breaks are like snowflakes. Each one is a little different. Sometimes there will be little games, 
              sometimes people share their backgrounds or talk about what they are working on right now.
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      <v-expansion-panel-content>
          <div slot="header">Should I provide food/drinks?</div>
          <v-card>
            <v-card-text>
              At a minimum, we recommend providing guests with water, coffee, tea, and fruit options. 
              The more you provide, the better experience the guests will have. 
              The goal is to get repeat guests at your wrkprtys!
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'host_dashboard_upcoming_events',
  data () {
    return {

    }
  },
  methods: {
    ...mapActions([
    ])
  },
  computed: {
    ...mapGetters([
      
    ])
  }
}
</script>

<style>

</style>
